<template>
  <div class="box">
    <el-card>
      <el-button type="primary" @click="chios">选择模板</el-button>
    </el-card>
    <el-form :model="userBookCaseHistoryVo" label-width="100px">
      <label
        style="
          font-weight: bold;
          margin-bottom: 20px;
          display: block;
          margin-left: 20px;
          margin-top: 20px;
        "
        >基本信息</label
      >
      <el-row>
        <el-col :span="8">
          <el-form-item label="姓名">
            <el-input v-model="userobj.hzxm" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="性别">
            <el-input :value="userobj.Sex" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="年龄">
            <el-input v-model="userobj.age" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="科别">
            <el-input v-model="userobj.ksmc" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="门诊号">
            <el-input
              v-model="
                userBookCaseHistoryVo.clinicNumber
                  ? userBookCaseHistoryVo.clinicNumber
                  : userobj.hosPatid
              "
              :disabled="true"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <label
        style="
          font-weight: bold;
          margin-bottom: 20px;
          display: block;
          margin-left: 20px;
        "
        >疾病信息</label
      >
      <el-row>
        <el-col :span="12"
          ><div class="grid-content">
            <el-form-item label="主诉">
              <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入主诉"
                v-model="userBookCaseHistoryVo.actionInChief"
              >
              </el-input>
            </el-form-item></div
        ></el-col>
        <el-col :span="12"
          ><div class="grid-content">
            <el-form-item label="现病史">
              <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入现病史"
                v-model="userBookCaseHistoryVo.historyPresentIllness"
              >
              </el-input>
            </el-form-item></div
        ></el-col>
      </el-row>
      <el-row>
        <el-col :span="12"
          ><div class="grid-content">
            <el-form-item label="过敏史">
              <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入过敏史"
                v-model="userBookCaseHistoryVo.drugAllergyHistory"
              >
              </el-input>
            </el-form-item></div
        ></el-col>
        <el-col :span="12"
          ><div class="grid-content">
            <el-form-item label="辅助检查结果">
              <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入辅助检查结果"
                v-model="userBookCaseHistoryVo.auxiliaryExamination"
              >
              </el-input>
            </el-form-item></div
        ></el-col>
      </el-row>
      <el-row>
        <el-col :span="12"
          ><div class="grid-content">
            <el-form-item label="诊断">
              <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入诊断"
                v-model="diagnosis"
              >
              </el-input>
            </el-form-item></div
        ></el-col>
        <el-col :span="12"
          ><div class="grid-content">
            <el-form-item label="处理">
              <el-input
                type="textarea"
                :rows="3"
                :placeholder="recipeOrderInfoList"
                v-model="handle"
              >
                <!-- v-model="recipeOrderInfoList" -->
              </el-input>
            </el-form-item>
          </div></el-col
        >
      </el-row>
      <el-form-item style="text-align: center">
        <el-button type="primary" @click="submitForm()">保存</el-button>
        <el-button style="margin-left: 30px" @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>

    <!-- 选择模板 -->
    <el-dialog
      title="选择模板"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
    >
      <el-table :data="gridData"  @selection-change="handleSelectionChange" ref="tb">
        <el-table-column type="selection"></el-table-column>  
        <el-table-column
          property="templateName"
          label="模板名称"
        ></el-table-column>
        <el-table-column
          property="deptName"
          label="科室"
        ></el-table-column>
        <el-table-column property="docName" label="医生名称"></el-table-column>
        <el-table-column property="createTime" label="创建时间" :formatter="formatUnix"></el-table-column>
      </el-table>
      <el-row
        class="pagination-wrapper"
        type="flex"
        justify="end"
        style="margin-top: 30px"
      >
        <el-pagination
          layout="total,sizes,prev, pager, next"
          @size-change="handleSizeChange"
          :current-page.sync="page.pageNum"
          @current-change="onCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          :total="page.total"
        ></el-pagination>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="determine"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { formatUnixTime } from "../../utils/DateFormat.js";
import axiosUtil from "../../utils/AxiosUtils.js";
export default {
  data() {
    return {
      page: {
        pageNum: 1,
        pageSize: 10,
        pages: 1,
        total: 0,
      },
      gridData:[],
      dialogVisible: false,
      userBookCaseHistoryVo: {
        auxiliaryExamination: "",
        historyPresentIllness: "",
        actionInChief: "",
        clinicNumber: "",
        drugAllergyHistory: "",
      },
      recipeOrderInfoList: "",
      recipeOrderList: "",
      handle: "",
      handleStr: "",
      allergicHistory: "",
      diagnosis: "",
      chek:null
    };
  },
  props: ["userobj"],
  created() {
    this.userobj.Sex = this.getSex(this.userobj.zjhm);
    this.userobj.age = this.getAge(this.userobj.zjhm);
  },
  mounted() {
    this.initData();
  },
  methods: {
    determine(){
      this.dialogVisible=false;
      this.userBookCaseHistoryVo.actionInChief=this.chek[0].actionInChief;
      this.userBookCaseHistoryVo.auxiliaryExamination=this.chek[0].auxiliaryExamination;
      // this.userBookCaseHistoryVo.drugAllergyHistory=this.chek[0].drugAllergyHistory;
      this.userBookCaseHistoryVo.historyPresentIllness=this.chek[0].historyPresentIllness;
    },
    formatUnix: function (row, column) {
      //格式化时间格式
      return formatUnixTime(row.createTime, "yyyy-MM-dd HH:mm");
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.initData();
    },
    onCurrentChange(pageNum) {
      this.page.pageNum = pageNum;
      this.initData();
    },
    handleSelectionChange(val){
      if(val.length > 1){
        this.$refs.tb.clearSelection()
        this.$refs.tb.toggleRowSelection(val.pop())
      }else{
        this.chek = val;
      }  
    },
    onSelectAll () {
      this.$refs.tb.clearSelection()
    },
    async chios() {
      this.dialogVisible = true;
      let that = this;
      const options = {
        docId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
        pageNum: that.page.pageNum,
        pageSize: that.page.pageSize,
        token: localStorage.getItem("token"),
      };
      let { code, obj } = await this.$http(
        "smarthos.user.book.case.history.template.list",
        options
      );
      if (code == "0") {
        that.page.total = obj.amout;
        if (obj.userBookCaseHistoryTemplateList) {
          that.gridData = obj.userBookCaseHistoryTemplateList;
        }else{
          that.gridData=[];
        }
      }
    },
    handleClose(done) {
      done();
    },
    getAge(idCardNum) {
      if (!idCardNum) return;
      let date = new Date();
      let year = date.getFullYear();
      return year - idCardNum.substring(6, 10);
    },
    getSex(idCardNum) {
      if (!idCardNum) return;
      let date = new Date();
      let year = date.getFullYear();
      this.age = year - idCardNum.substring(6, 10);
      if (idCardNum.substring(16, 17) % 2 == 0) {
        return "女";
      } else return "男";
    },
    cancel() {
      this.$router.push({ path: "/main" });
    },
    initData(p) {
      let that = this;
      axiosUtil(
        {
          service: "smarthos.user.book.case.history.max.create.time.record",
          commonPatId: that.userobj.visitid,
          token: localStorage.getItem("token"),
          bookId: that.userobj.ddid,
          bookOrderNumber: that.userobj.bookOrderNumber,
        },
        ({ code, obj, msg }) => {
          if (code == "0") {
            if (obj.diagnosis) {
              that.diagnosis = obj.diagnosis;
            }
            if (obj.allergicHistory) {
              that.userBookCaseHistoryVo.drugAllergyHistory =
                obj.allergicHistory;
            }
            if (obj.recipeOrderInfoList) {
              that.recipeOrderInfoList = obj.recipeOrderInfoList;
              let str1 = "";
              let str2 = "";
              for (let i in obj.recipeOrderInfoList) {
                str1 +=
                  obj.recipeOrderInfoList[i].drugName +
                  " " +
                  obj.recipeOrderInfoList[i].drugSpecification +
                  " " +
                  obj.recipeOrderInfoList[i].admission +
                  " " +
                  obj.recipeOrderInfoList[i].frequencyName +
                  " " +
                  "每次" +
                  obj.recipeOrderInfoList[i].dosage +
                  obj.recipeOrderInfoList[i].dosageUnit +
                  "";
                str2 +=
                  obj.recipeOrderInfoList[i].drugName +
                  " " +
                  obj.recipeOrderInfoList[i].drugSpecification +
                  " " +
                  obj.recipeOrderInfoList[i].admission +
                  " " +
                  obj.recipeOrderInfoList[i].frequencyName +
                  " " +
                  "每次" +
                  obj.recipeOrderInfoList[i].dosage +
                  obj.recipeOrderInfoList[i].dosageUnit +
                  "</br>";
              }
              that.recipeOrderInfoList = str1;
              that.handleStr = str2;
            }
            if (obj.recipeOrderList) {
              let str = "";
              for (let i in obj.recipeOrderList) {
                str += obj.recipeOrderList[i].allergyHistory + ";";
              }
              that.recipeOrderList = str;
            }
            // if (obj.userBookCaseHistoryVo) {
            //   // that.allergicHistory = obj.allergicHistory;
            //   that.userBookCaseHistoryVo.drugAllergyHistory=obj.userBookCaseHistoryVo.userBookCaseHistoryVo;
            //   // that.userBookCaseHistoryVo = obj.userBookCaseHistoryVo;
            //   // that.userBookCaseHistoryVo.commonPatAge = that.getAge(
            //   //   that.userBookCaseHistoryVo.commonPatIdcard
            //   // );
            //   that.userBookCaseHistoryVo.clinicNumber = that.userobj.hosPatid;
            // }
          }
        }
      );
    },
    getAge(idCardNum) {
      if (!idCardNum) return;
      let date = new Date();
      let year = date.getFullYear();
      return year - idCardNum.substring(6, 10);
    },
    submitForm() {
      let that = this;
      axiosUtil(
        {
          service: "smarthos.user.book.case.history.save",
          bookId: that.userobj.ddid,
          bookOrderNumber: that.userobj.bookOrderNumber,
          visitTime: that.userobj.ghrq + " " + that.userobj.czsj,
          bookNum: that.userobj.bookNum,
          docId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
          commonPatId: that.userobj.visitid,
          auxiliaryExamination: that.userBookCaseHistoryVo.auxiliaryExamination,
          drugAllergyHistory: that.userBookCaseHistoryVo.drugAllergyHistory,
          actionInChief: that.userBookCaseHistoryVo.actionInChief,
          historyPresentIllness:
            that.userBookCaseHistoryVo.historyPresentIllness,
          diagnose: that.diagnosis,
          treatmentOptions: that.handleStr ? that.handleStr : that.handle,
          treatmentOptionsInput: that.handle,
          clinicNumber: that.userBookCaseHistoryVo.clinicNumber,
          token: localStorage.getItem("token"),
        },
        ({ code, obj, msg }) => {
          if (code == "0") {
            that.$message({
              type: "success",
              message: "保存成功,请前往病历列表签名",
            });
            that.$router.push({ path: "/main/medicalRecord" });
          }
        }
      );
    },
  },
};
</script>
<style>
.box {
  background: #fff;
  overflow: hidden;
}
</style>